import React, { useEffect, useState, useCallback } from 'react';
import { Sparkles } from 'lucide-react';

export const MilestoneCelebration = ({ streak, onClose }) => {
  const [show, setShow] = useState(false);
  const [milestone, setMilestone] = useState(null);

  const handleClose = useCallback(() => {
    setShow(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    // Check if streak is a milestone
    const milestones = {
      7: { title: 'One Week Strong!', message: 'Seven days of showing up for yourself.' },
      14: { title: 'Two Weeks of Growth', message: 'Your consistency is building momentum.' },
      30: { title: 'One Month Milestone', message: 'A full month of dedicated healing work.' },
      60: { title: 'Two Months of Healing', message: 'Your commitment to yourself shines through.' }
    };

    if (milestones[streak]) {
      setMilestone(milestones[streak]);
      setShow(true);
      
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [streak, handleClose]);

  if (!show || !milestone) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-white/90 backdrop-blur-md border-2 border-amber-200 shadow-2xl rounded-3xl p-12 max-w-md mx-6 text-center animate-in zoom-in duration-500">
        {/* Gentle glow animation */}
        <div className="relative mb-6">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 bg-amber-200 rounded-full blur-3xl opacity-50 animate-pulse" />
          </div>
          <div className="relative">
            <Sparkles className="w-20 h-20 text-amber-500 mx-auto animate-pulse" strokeWidth={1.5} />
          </div>
        </div>

        <h2
          className="text-3xl font-medium text-stone-800 mb-4 animate-in slide-in-from-bottom duration-700"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          {milestone.title}
        </h2>
        
        <p className="text-lg text-stone-600 mb-2 animate-in slide-in-from-bottom duration-700 delay-100">
          {milestone.message}
        </p>
        
        <p className="text-4xl font-semibold text-amber-600 mb-8 animate-in slide-in-from-bottom duration-700 delay-200">
          {streak} Days
        </p>

        <button
          onClick={handleClose}
          className="px-8 py-3 bg-stone-800 text-stone-50 rounded-full hover:bg-stone-700 transition-all duration-300 hover:scale-105"
        >
          Continue
        </button>
      </div>
    </div>
  );
};
